var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { AfyEditableTable } from "@affinitysystemsgroup/assurehub-ui";
export var StyledCodesTable = styled(AfyEditableTable)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & th {\n    color: var(--mantine-color-gray-6);\n  }\n"], ["\n  & th {\n    color: var(--mantine-color-gray-6);\n  }\n"])));
var templateObject_1;
